import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from
    "@angular/forms"
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { SpinnerOverlayService } from '../../../../services/spinner-overlay.service';
import { UMPCategory, Utils } from '../../../../utils/utils';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { AddGroupDialogue } from '../../home/edituser/addgroupdialogue/addgroupdialogue.component';     

@Component({
    selector: "group-maxroles",
    templateUrl: './maxroles.component.html',
    styleUrls: ['./maxroles.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class GroupMaxRoles implements OnInit {
    public userName: String = '';
    userId = ''
    dataCopy: any;
    
    searchString: string = '';
    filteredMaxRoles: any[] = [];

    MaxRoles = [];
    Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    errorResponse: any;
    isCallSucceed: number = 0;

    @ViewChild(MatSelectionList) selectionList!: MatSelectionList;

    dialogRef: MatDialogRef<AddGroupDialogue, any> | undefined

    AllAzDevProj = [];
    UserAzDevProj = [];
    RemainAzDevProj = [];


    

    constructor(
        private route: ActivatedRoute,
        private http: HttpClient,
        private toastrService: ToastrService,
        private dialogForm: MatDialog,
        private spinnerOverlayService: SpinnerOverlayService,
        private defaults: DefaultValuesService,

   
        @Inject('BASE_URL') private baseUrl: string
    ) {

        this.updateRolesResults();

        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        
        defaults.resetBulkGroupTrigger$.subscribe(() => this.resetData())

        
        this.funcGetMaxRoles();

        
    }

    ngOnInit() {

    }
    updateRolesResults() {
        this.filteredMaxRoles = this.searchByValue(this.MaxRoles, "persona", this.searchString);
    }

    isRoleSelected(item): boolean {
        return this.defaults.groupList.some(group =>
            group.Id === item.id && group.UmpCategory === UMPCategory.MaxRoles
        );
    }

    searchByValue(items:any,filterProperty:string,query:string) {
        
        return items.filter(item => {
            if (query.trim() === '') {
                return true;
            } else {
                return item[filterProperty].toLowerCase().includes(query.trim().toLocaleLowerCase())
            }
        })   
    }
   
   
   
    funcGetMaxRoles() {
        this.Response_State = -2;
        Utils.httpGetAllMaxRoles(
            this.http
            , this.baseUrl
            , 'maxrole'
            , this
            , function (tthis: GroupMaxRoles, data: any) {
                tthis.dataCopy = structuredClone(data)
                tthis.assignValues(data)
            }
        )
    }
    assignValues(data) {
        this.MaxRoles = data.personae
        this.updateRolesResults();

        if (this.MaxRoles?.length) {
            this.Response_State = 1;
        }
        else {
            this.Response_State = 0;

        }
    }
    resetData() {
        this.selectionList?.deselectAll();
        this.assignValues(structuredClone(this.dataCopy))
    }


    funcNotify(persona) {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Delete "' + persona + '"  request sent successfully !', 'Max Role Delete Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Delete "' + persona + '"  request not sent successfully !', 'Max Role Delete Request!');
        }
    }
    itemSelected(event) {
        if (event.options[0]._selected) {
            this.onSelect(event.options[0]._value);
        } else {
            this.onDeselect(event.options[0]._value);
        }
    }

    onSelect(selectedItem) {
        this.defaults.addGroupListItem({ Personae: selectedItem.persona, Id: selectedItem.id, UmpCategory: UMPCategory.MaxRoles });

    }

    onDeselect(selectedItem) {
        this.defaults.removeGroupListItem(selectedItem.id);

    }

   
}